export enum MotivoDependencia {
  NASCIMENTO = 10,
  INVALIDEZ = 11,
  CASAMENTO = 12,
  UNIAO_ESTAVEL = 13,
  ADOCAO = 14,
  DECISAO_JUDICIAL = 15,
  DEPENDENCIA_ECONOMICA = 16,
  FILHO_POSTUMO = 17,
  TUTELA = 18,
  DESIGNACAO_EXPRESSA_PELO_SERVIDOR = 19,
  OUTROS = 98
}

export const MotivoDependenciaOptions = [
  { value: MotivoDependencia.NASCIMENTO, label: 'Nascimento' },
  { value: MotivoDependencia.INVALIDEZ, label: 'Invalidez' },
  { value: MotivoDependencia.CASAMENTO, label: 'Casamento' },
  { value: MotivoDependencia.UNIAO_ESTAVEL, label: 'União Estável' },
  { value: MotivoDependencia.ADOCAO, label: 'Adoção' },
  { value: MotivoDependencia.DECISAO_JUDICIAL, label: 'Decisão Judicial' },
  { value: MotivoDependencia.DEPENDENCIA_ECONOMICA, label: 'Dependência Econômica' },
  { value: MotivoDependencia.FILHO_POSTUMO, label: 'Filho Póstumo' },
  { value: MotivoDependencia.TUTELA, label: 'Tutela' },
  { value: MotivoDependencia.DESIGNACAO_EXPRESSA_PELO_SERVIDOR, label: 'Designação Expressa pela Servidor' },
  { value: MotivoDependencia.OUTROS, label: 'Outros' },
];
